import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { User } from '../../../models/user';


@Component({
    selector: 'comment-mention',
    templateUrl: './comment-mention.component.html',
    styleUrls: ['./comment-mention.component.scss'],
    standalone: false
})
export class CommentMentionComponent {
  @Input() users: User[] = [];

  @Output() userSelected = new EventEmitter<User>();

  selectUser(user: User): void {
    this.userSelected.emit(user);
  }
}
